<template>
  <div class="audience-content" :id="chartId">

    <div class="hidden-chart-name">
      {{title}} <b>{{charDateTitle}}</b>
    </div>
    <div class="chart-count">
      <span>{{$t('feed.audit.audience.body.title')}}: <b>{{totalCount}}</b></span>
    </div>

    <div class="audience-chart__wrap">
      <div class="audience-chart__wrap-item">
        <line-chart
          v-if="isLoaded"
          :chart-data="dataLineCollection"
          :options="lineOptions"
          selector=".audience-chart__wrap-item"
          class="audience-content__chart"
          :height="height"
        ></line-chart>
      </div>
    </div>


    <div class="chart-show-labels" data-html2canvas-ignore="true" @click="toggleLabel">
      <el-checkbox :value="showLabel" @change="toggleLabel">{{$t('feed.audit.audience.body.captions')}}</el-checkbox>
    </div>
    <a href="" :id="`download${chartId}`"></a>
  </div>
</template>

<script>
  // chart
  import { LineChart } from "../../../../../../../../components/charts";

  // mixins
  import audience from "../../../../../../../../mixins/chart/audience";
  import saveImage from "../../../../../../../../mixins/saveImage";

  // config
  import tonal from "../../../../../../../../config/tonals";

  // moment
  import moment from 'moment';

  export default {
    name: "AudienceBody",
    props: {
      data: {
        type: Object,
        required: true
      },
      chartName: {
        type: String
      },
      saveChart: {
        type: Boolean,
        default: false
      },
      title: {
        type: String
      }
    },
    data() {
      return {
        tonal: tonal,
        chartId: "ReachAudience",
        format: "DD.MM.YYYY",
        showLabel: true,
        selector: '.audience-content__chart canvas',
        height: 350,
      }
    },
    methods: {
      toggleLabel () {
        this.showLabel = !this.showLabel;
      },
    },
    computed: {
      periodName() {
        return this.$store.getters.auditPeriodName(this.chartName);
      },
      chartDate() {
        return this.$store.getters.getAuditPeriod(this.chartName);
      },
      charDateTitle () {
        return `${moment(this.chartDate[0]).format(this.format)} - ${moment(this.chartDate[1]).format(this.format)}`;
      },
      isLoaded() {
        return this.$store.getters.isAuditLoaded(this.chartName);
      }
    },
    mixins: [
      audience,
      saveImage
    ],
    components: {
      LineChart
    }
  };
</script>

<style>
  @import "../../../../../../../../style/tonal.css";
  .audience-chart__wrap {
    position: relative;
    overflow-x: auto;
    height: 375px;
  }
  .audience-chart__wrap-item {
    position: relative;
  }
  .audience-content__chart {
    margin-bottom: 10px;
  }
  .chart-count {
    display: flex;
    justify-content: center;
    padding: 20px 10px;
    font-size: 16px;
  }
  .chart-show-labels {
    display: flex;
    justify-content: start;
    padding: 20px 10px;
    font-size: 16px;
  }
</style>
